export default String.raw`
<div class="page-padding">
    {% include 'partials/common/login.html' -%} 
</div>
    {% if usr.Authenticated -%}
        <div class="login-container">
            <div>{{ translations.YouAreLoggedInAs }}: {{ usr.Email }}</div>
            <div>{{ translations.GoToClientProfile }} <a href="{{ page.BaseHref }}{{config.DefinedPages.CustomerProfile.Url}}?tab=orders" rel="nofollow" target="_blank">{{translations.CustomerProfile}}</a></div>
        </div>
    {% endif -%}
`